import script from "./CollectionItemCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemCount.vue?vue&type=script&lang=js"
export * from "./CollectionItemCount.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItemCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-collection-card/CollectionItemCount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3179aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3179aa2', __exports__)) {
    api.reload('a3179aa2', __exports__)
  }
  
}


export default __exports__